var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31548_47570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3523 3.7471C32.9613 2.27226 31.8058 1.11097 30.3406 0.716129C27.6852 0 17.0323 0 17.0323 0C17.0323 0 6.37936 0 3.72387 0.716129C2.25871 1.11097 1.10323 2.27226 0.712258 3.7471C0 6.42194 0 12 0 12C0 12 0 17.5781 0.712258 20.2529C1.10323 21.7277 2.25871 22.889 3.72387 23.2839C6.38129 24 17.0323 24 17.0323 24C17.0323 24 27.6852 24 30.3406 23.2839C31.8058 22.889 32.9613 21.7277 33.3523 20.2529C34.0645 17.58 34.0645 12 34.0645 12C34.0645 12 34.0645 6.42194 33.3523 3.7471Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5488 17.0678L22.4521 12.0027L13.5488 6.9375V17.0678Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31548_47570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.0645,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.1cc2efa0ae1e22ecb57810c5964642cb.svg";
export { ForwardRef as ReactComponent };